import { GET_FOOD_TYPES_LOADING, GET_FOOD_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getFoodTypesSuccess = payload => {
    return ({
        type: GET_FOOD_TYPES_SUCCESS,
        payload
    })
}

export const getFoodTypesAsync = payload => dispatch => {
    return client.service('food-types').find()
		.then((response) => {
            dispatch(getFoodTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}